import {toast} from '@utils/dlg'
import {PAGE_SAVE} from '@store/mutation-types'

class Pager {
  constructor (count) {
    this.total = 0
    this.count = count
    this.page = 1
  }

  addPage (page = 1) {
    this.page += page
    return this
  }

  subPage (page = 1) {
    if (this.page - page > 0) this.page -= page
    return this
  }

  get params () {
    return {
      page: this.page,
      count: this.count
    }
  }
}

export {
  errorFn,
  getQueryVariable,
  loginRouteGo,
  setLoginRoute,
  getAge,
  getPassportAge,
  Pager
}

function errorFn (error) {
  if (error) {
    toast.e(error.message)
  } else {
    console.log('error', error)
  }
}

function getQueryVariable (variable) {
  let query = window.location.search.substring(1)
  let vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return (false)
}

function loginRouteGo (route) {
  let localRoute = localStorage.getItem(PAGE_SAVE)
  localStorage.removeItem(PAGE_SAVE)
  let str = {name: 'Shop'}
  if (localRoute) {
    str = JSON.parse(localRoute)
  }
  route.push(str)
}

function setLoginRoute (route) {
  localStorage.removeItem(PAGE_SAVE)
  let r = {name: 'Shop'}
  if (route) {
    if (route.name) r.name = route.name
    if (route.query) r.query = route.query
    if (route.params) r.params = route.params
  }
  let str = JSON.stringify(r)
  localStorage.setItem(PAGE_SAVE, str)
}

function getAge (identityCard) {
  let len = (identityCard + '').length
  if (len === 0) {
    return 0
  } else {
    if ((len !== 15) && (len !== 18)) {
      return 0
    }
  }
  let strBirthday = ''
  if (len === 18) {
    strBirthday = identityCard.substr(6, 4) + '/' + identityCard.substr(10, 2) + '/' + identityCard.substr(12, 2)
  }
  if (len === 15) {
    strBirthday = '19' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
  }
  let birthDate = new Date(strBirthday)
  let nowDateTime = new Date()
  let age = nowDateTime.getFullYear() - birthDate.getFullYear()
  if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() === birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}

function getPassportAge (birthday) {
  let birthDate = new Date(birthday)
  let nowDateTime = new Date()
  let age = nowDateTime.getFullYear() - birthDate.getFullYear()
  if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() === birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}



// WEBPACK FOOTER //
// ./src/utils/api.js